/**
 * Herbalife Popup – Script principale
 * ----------------------------------
 * - Mostra il popup informativo Herbalife
 * - Una sola volta per utente (cookie funzionale)
 * - Solo in homepage
 * - Chiudibile con overlay, X, link e tasto ESC
 * - Nessun impatto SEO
 */

(function () {
  'use strict';

  /* ==============================
     CONFIGURAZIONE
  ============================== */

  // ID elementi HTML
  const ROOT_ID = 'herbalifepopup';      // wrapper principale
  const POPUP_ID = 'wc_herba_popup';     // popup box

  // Cookie
  const COOKIE_NAME = 'wc_popup_herba';
  const COOKIE_DAYS = 3650; // ~10 anni (come il sito di riferimento)

  // Ritardo apertura (ms)
  const OPEN_DELAY = 300;

  /* ==============================
     FUNZIONI COOKIE
  ============================== */

  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie =
      name +
      '=' +
      value +
      '; expires=' +
      d.toUTCString() +
      '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length);
      }
    }
    return '';
  }

  /* ==============================
     FUNZIONI POPUP
  ============================== */

  function openPopup(root) {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
  }

  function closePopup(root) {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
  }

  /* ==============================
     AVVIO SCRIPT
  ============================== */

  document.addEventListener('DOMContentLoaded', function () {

    /* ---- Mostra SOLO in homepage ---- */
    if (window.location.pathname !== '/') return;

    /* ---- (OPZIONALE) Mostra solo da campagne Ads ----
    const qs = new URLSearchParams(window.location.search);
    const isAds =
      qs.has('gclid') ||
      qs.has('gbraid') ||
      qs.has('wbraid') ||
      qs.has('gad_campaignid');
    if (!isAds) return;
    ----------------------------------- */

    const root = document.getElementById(ROOT_ID);
    const popup = document.getElementById(POPUP_ID);

    // Sicurezza: se manca markup, esci
    if (!root || !popup) return;

    /* ---- Controllo cookie ---- */
    const alreadyShown = getCookie(COOKIE_NAME) === 'shown';
    if (alreadyShown) return;

    /* ---- Apertura popup ---- */
    window.setTimeout(function () {
      openPopup(root);
      setCookie(COOKIE_NAME, 'shown', COOKIE_DAYS);
    }, OPEN_DELAY);

    /* ---- Click per chiudere ---- */
    root.addEventListener('click', function (e) {
      const target = e.target;

      // Chiudi se:
      // - click su overlay
      // - click su X
      // - click su link "clicca qui"
      if (
        target.classList.contains('herbalife-bg') ||
        target.classList.contains('herbalife-close') ||
        target.hasAttribute('data-wc-close')
      ) {
        e.preventDefault();
        closePopup(root);
      }
    });

    /* ---- Chiudi con ESC ---- */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) {
        closePopup(root);
      }
    });

  });
})();
